<template>
  <div class="button-controller">
    <div class="button-control-item" v-for="(btn, index) in buttonList" :key="btn.name"
         @click="selectButton(index)"
         :class="[{active:selectedBtn.name === btn.name}, activeColor]"
    >
      <div class="control-label">
        <span v-if="btn.addText">가비아<br></span>
        {{btn.title}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ButtonControl',
  data() {
    return {
      selectedBtn: '',
    };
  },
  props: {
    buttonList: {
      type: Array,
      require: true,
    },
    activeColor: {
      type: String,
      default: 'green',
    },
    selectIndex: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.selectButton(this.selectIndex);
  },
  methods: {
    selectButton(index) {
      this.selectedBtn = this.buttonList[index];
      this.$emit('select', this.selectedBtn);
    },
  },
};
</script>

<style lang="scss" scoped>
.button-controller {
  position: relative;
  margin: 16px 0;
  width: 100%;
  height: 1px;
  background-color: #0a0a0a;
  display: flex;
  justify-content: space-between;
  .button-control-item {
    cursor: pointer;
    outline: 0;
    width: 16px;
    height: 16px;
    border: 1px solid #0a0a0a;
    border-radius: 50%;
    background-color: #fff;
    position: relative;
    transform: translateY(-50%);
    .control-label {
      font-size: 18px;
      font-weight: 400;
      line-height: 1.5;
      position: absolute;
      min-width: 80px;
      text-align: center;
      top: 30px;
      left: 50%;
      transform: translateX(-50%);
    }
    &.active {
      &.green {
        background-color: #72CE16;
      }
      &.purple {
        background-color: #B080FD;
      }
    }
  }
}
</style>
